// HeaderFireworks.js
import React from "react";
import FireworksEffect from "./FireworksEffect";

const HeaderFireworks = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
        pointerEvents: "none",
        overflow: "hidden"
      }}
    >
      <FireworksEffect />
    </div>
  );
};

export default HeaderFireworks;